// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/solid/calendar.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'calendar',
  version: 'solid',
  paths: [
    {
      d: 'M6.9 2.4a.9.9 0 0 1 .9.9v1.5h8.4V3.3a.9.9 0 0 1 1.8 0v1.5h.3a3.3 3.3 0 0 1 3.3 3.3v10.2a3.3 3.3 0 0 1-3.3 3.3H5.7a3.3 3.3 0 0 1-3.3-3.3V8.1a3.3 3.3 0 0 1 3.3-3.3H6V3.3a.9.9 0 0 1 .9-.9M5.7 9c-.828 0-1.5.672-1.5 1.5v7.8c0 .828.672 1.5 1.5 1.5h12.6c.828 0 1.5-.672 1.5-1.5v-7.8c0-.828-.672-1.5-1.5-1.5H5.7',
      fillRule: 'evenodd',
    },
  ],
}
